import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-fancy-box',
  templateUrl: './fancy-box.component.html',
  styleUrls: ['./fancy-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FancyBoxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/fancy-box/fancy-box.component.ts